import {Component, Input, OnInit} from '@angular/core';
import {BaseDialog} from '../../base-dialog';
import {NbDialogRef} from '@nebular/theme';
import {Router} from '@angular/router';

export interface FieldEditor {
  description: string,
  keyName: string
}

@Component({
  selector: 'app-field-editor-dialog',
  templateUrl: './field-editor-dialog.component.html',
  styleUrls: ['./field-editor-dialog.component.css']
})
export class FieldEditorDialogComponent extends BaseDialog<any> implements OnInit {

  @Input()
  description: string;

  @Input()
  object: any;

  @Input()
  keysToEdit: FieldEditor[];

  constructor(dialogRef: NbDialogRef<any>, route: Router) {
    super(dialogRef, route);
  }

  ngOnInit(): void {
  }

}
